import React from 'react';
import { Consumer } from './CurrentUserContext';

const CurrentUser = ({ render, renderLoading }) => {
  return (
    <Consumer>
      {({ loading, user }) => (loading ? renderLoading() : render(user))}
    </Consumer>
  );
}

CurrentUser.defaultProps = {
  renderLoading: () => null
}

export default CurrentUser;



// WEBPACK FOOTER //
// ./src/components/CurrentUser.js